import {z} from 'zod'
import axios from '@/axiosInstance.ts'
import {useAuthStore} from '@features/user/store/store.ts'

export const HttpCancelShootParams = z.object({
    assignmentId: z.coerce.number().int(),
    values: z.object({
        reason_id: z.number().optional(),
        by: z.string().optional(),
        notes: z.string().optional()
    })
})
export type HttpCancelShootParams = z.infer<typeof HttpCancelShootParams>

export const httpCancelShoot = (params: HttpCancelShootParams) => {
    const accessToken = useAuthStore.getState().accessToken
    const url = `/assignment/${params.assignmentId}/cancel`
    return axios.post(url, params.values, {
        params: {response_type: 'extended'},
        headers: {Authorization: `Bearer ${accessToken}`}
    })
}
